import { __extends, __read, __spreadArray } from "tslib";
var DomainError = (function (_super) {
    __extends(DomainError, _super);
    function DomainError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.details = {};
        return _this;
    }
    DomainError.prototype.getCause = function () {
        return this.previousError;
    };
    DomainError.prototype.getRootCause = function () {
        var previousErrors = this.getPreviousErrors();
        return previousErrors[previousErrors.length - 1];
    };
    DomainError.prototype.getPreviousErrors = function () {
        var previousError = this.previousError;
        if (!previousError)
            return [];
        if (previousError instanceof DomainError) {
            return __spreadArray([previousError], __read(previousError.getPreviousErrors()), false);
        }
        return [previousError];
    };
    Object.defineProperty(DomainError.prototype, "name", {
        get: function () {
            return this.previousError
                ? "".concat(this._name, "(").concat(this.previousError.name, ")")
                : this._name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DomainError.prototype, "_name", {
        get: function () {
            return this.constructor.name;
        },
        enumerable: false,
        configurable: true
    });
    DomainError.prototype.toString = function () {
        var currentErrorString = "".concat(this._name, ": ").concat(this.message);
        return this.previousError
            ? "".concat(currentErrorString, "\n\t").concat(this.previousError.toString())
            : currentErrorString;
    };
    DomainError.wrap = function (error, overrides) {
        var _a;
        if (overrides === void 0) { overrides = {}; }
        var domainError = new this((_a = overrides.message) !== null && _a !== void 0 ? _a : error.message);
        Object.assign(domainError, overrides, { previousError: error });
        return domainError;
    };
    DomainError.create = function (message, overrides) {
        if (overrides === void 0) { overrides = {}; }
        var error = new this(message);
        Object.assign(error, overrides);
        return error;
    };
    return DomainError;
}(Error));
export { DomainError };
